module.exports = __webpack_public_path__ + "static/img/logo.067176d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/logo.png
// module id = xYTw
// module chunks = 40